import React, { useEffect, useState } from "react";
import { ContentContainer } from "../../../components/layout";
import * as XLSX from "xlsx";
import {
  Button,
  Checkbox,
  CheckboxList,
  DateRangePicker,
  LoadingComponent,
  NetworkStrength,
  Select,
  SliderComponent,
  Table,
  Textarea,
  Textfield,
} from "../../../components/core";
import { Tooltip } from "recharts";
import { useDispatch, useSelector } from "react-redux";
import { useLazyQuery, useQuery } from "@apollo/client";
import {
  LOCKER_USER_ACCOUNTS,
  USER_STATUS_HISTORY,
} from "../../../constants/graphql/locker-user-accounts-queries";
import {
  getLockerUserAccountsList,
  handleChangeReducer,
  resetSearchCriteria,
  setSearchCriteria,
} from "../../../features/locker-user-accounts/locker-user-accounts-slice";
import { NumericFormat } from "react-number-format";
import TotalRecords from "../../../components/core/total-records";
import PrimereactDateRange from "../../../components/core/date-range-primereact";
import { InputText } from "primereact/inputtext";
import { formatDateYYYYMMDD } from "../../../algorithms/date";
import { InputNumber } from "primereact/inputnumber";
import { Card } from "primereact/card";
const VERIFIED_STATUS = [
  { value: "0", name: "Unverified" },
  { value: "1", name: "Verified" },
  { value: "2", name: "Pending verification" },
  { value: "3", name: "Rejected" },
];
function removeEmptyFields(obj) {
  for (const key in obj) {
    if (
      obj[key] === null ||
      obj[key] === undefined ||
      obj[key] === "" ||
      obj[key] === "-1" ||
      obj[key].length < 1 ||
      obj[key] === "0"
    ) {
      delete obj[key];
    }
  }
  return obj;
}
function formatDate(inputDate) {
  const options = { year: "numeric", month: "short", day: "numeric" };
  const date = new Date(inputDate);
  return date.toLocaleDateString("en-US", options);
}
const downloadExcel = () => {
  const ws = XLSX.utils.table_to_sheet(
    document.getElementById("cleanup-table")
  );
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

  XLSX.writeFile(wb, `${"cleanup-report"}.xlsx`);
};

export default function LockerUserAccounts() {
  const accessPermission = useSelector(
    (state) => state.accessPermissions.accessPermissions
  );
  // UTILS
  const dispatch = useDispatch();
  // REDUX STATES
  const dt = React.useRef();
  const searchCriteria = useSelector(
    (state) => state.lockerUserAccounts.searchCriteria
  );
  const lockerUserAccountsList = useSelector(
    (state) => state.lockerUserAccounts.lockerUserAccountsList
  );
  // LOCAL STATE
  const [allAgeFlag, setAllAgeFlag] = React.useState(true);
  const [gender, setGender] = React.useState([
    { id: "0", text: "Unspecified", checked: false },
    { id: "1", text: "Male", checked: false },
    { id: "2", text: "Female", checked: false },
  ]);
  const [searchResultSentence, setSearchResultSentence] =
    React.useState("Search result for");
  // GQL
  const [lockerUserAccounts, { loading, data }] = useLazyQuery(
    LOCKER_USER_ACCOUNTS,
    { fetchPolicy: "no-cache" }
  );

  const [sendAppData, setSendAppData] = React.useState({
    open: false,
    operatorId: localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user")).operator_id
      : "",
    message: "",
    target: [],
    category: "-1",
    image: "",
    subject: "",
  });

  const [operatorID, setOperatorID] = useState("");

  // USE EFFECTS
  React.useEffect(() => {
    if (data) {
      let tempVar = [];
      data.lockerUserAccounts.forEach((element) => {
        let statusList = [
          { value: 0, name: "Unverified" },
          { value: 2, name: "Pending verification" },
          { value: 1, name: "Verified" },
          { value: 3, name: "Rejected" },
        ];
        tempVar.push({
          userId: element.user.userId,
          lockerUser: `${element.user.firstName} ${element.user.middleName} ${element.user.lastName}, ${element.user.suffixName}`,
          userMobile: element.user.userMobile,
          userEmail: element.user.userEmail ? element.user.userEmail : "N / A",
          birthDate: element.user.birthDate
            ? formatDate(element.user.birthDate)
            : "N / A",
          verifiedStatus: statusList.find(
            (x) => x.value === element.user.verifiedStatus
          )
            ? statusList.find((x) => x.value === element.user.verifiedStatus)
                .name
            : "Unknown",
          signupDate: element.user.createdAt,
          userType: element.userType.userType,
        });
      });
      dispatch(getLockerUserAccountsList(tempVar));
    }
  }, [data]);

  useEffect(() => {
    const fetchOperatorID = () => {
      let opIDLocal = localStorage.getItem("user");
      let opIDLocal2 = JSON.parse(opIDLocal);
      if (opIDLocal2) {
        setOperatorID(opIDLocal2.operator_id);
      }
    };

    fetchOperatorID();
  }, []);

  console.log({ searchCriteria });
  const handleSearchResult = () => {
    const start = formatDateYYYYMMDD(searchCriteria.signupDateFrom);
    const end = formatDateYYYYMMDD(searchCriteria.signupDateInto);
    console.log({ searchCriteria });
    let tempObj = { ...searchCriteria };

    let genderList = [];
    gender.forEach((element) => {
      if (element.checked) {
        genderList.push(element.id);
      }
    });
    tempObj["gender"] = genderList;
    let filteredObj = removeEmptyFields(tempObj);
    filteredObj.signupDateFrom = start;
    filteredObj.signupDateInto = end;
    filteredObj.operatorId = operatorID;
    if (searchCriteria.verifiedStatus === "-2") {
      delete filteredObj.verifiedStatus;
    } else {
      filteredObj.verifiedStatus = searchCriteria.verifiedStatus;
    }

    filteredObj.withApp =
      searchCriteria.withApp === "-2"
        ? null
        : searchCriteria.withApp === "0"
        ? false
        : true;

    console.log({ filteredObj });
    if (allAgeFlag) {
      delete filteredObj.ageFrom;
      delete filteredObj.ageTo;
    }
    console.log(filteredObj);
    lockerUserAccounts({
      variables: filteredObj,
      fetchPolicy: "no-cache",
    });
    setSearchResultSentence(`Search result for${" "}
		${
      searchCriteria.verifiedStatus !== "-2" &&
      searchCriteria.verifiedStatus !== -2
        ? VERIFIED_STATUS.find(
            (x) => x.value === String(searchCriteria.verifiedStatus)
          ).name
        : "ALL ID status"
    }${" "}
		${
      allAgeFlag
        ? "ALL Ages"
        : `${searchCriteria.ageFrom} to ${searchCriteria.ageTo} years old`
    }${" "},
		${
      searchCriteria.firstName === "" && searchCriteria.lastName === ""
        ? "ALL users"
        : `agent ${searchCriteria.firstName} ${searchCriteria.lastName}`
    }
		${
      searchCriteria.withApp === "-2" || searchCriteria.withApp === "-1"
        ? "with or without APP"
        : searchCriteria.withApp === "1"
        ? "with APP"
        : "without APP" // Handle other cases, if needed
    }

		${searchCriteria.userMobile && `using 63${searchCriteria.userMobile}`}
		${
      searchCriteria.signupDateFrom === "" &&
      searchCriteria.signupDateInto === ""
        ? "in ALL DATES"
        : `From ${start} To ${end}`
    }`);
  };
  const handleChange = (event) => {
    const { name, value } = event.target;
    console.log({ name, value });
    if (name == "verifiedStatus" && value == -1) {
      dispatch(handleChangeReducer({ name: name, value: 0 }));
    } else {
      dispatch(handleChangeReducer({ name: name, value: value }));
    }
  };

  console.log({ searchCriteria });
  const handleReset = () => {
    dispatch(resetSearchCriteria());
    setGender([
      { id: "0", text: "Unspecified", checked: false },
      { id: "1", text: "Male", checked: false },
      { id: "2", text: "Female", checked: false },
    ]);
  };
  return (
    <ContentContainer containerTitle={"Locker User Accounts"}>
      {/* mobile responsive container */}
      <div className="grid grid-cols-12 md:grid-cols-6">
        {/* search field */}
        <div className="col-span-12 md:col-span-6">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-2">
            {/* Name Field */}
            <div className="col-span-1 md:col-span-12">
              <div className="grid grid-cols-1 md:grid-cols-12 gap-2">
                <div className="col-span-1 md:col-span-3">
                  <p className="text-base">Name:</p>
                </div>
                <div className="col-span-1 md:col-span-5">
                  <div className="grid grid-cols-2 gap-2">
                    <div className="col-span-1">
                      <Textfield
                        type="text"
                        name="lastName"
                        value={searchCriteria.lastName}
                        onChange={handleChange}
                        placeholder="Surname"
                      />
                    </div>
                    <div className="col-span-1">
                      <Textfield
                        type="text"
                        name="firstName"
                        value={searchCriteria.firstName}
                        onChange={handleChange}
                        placeholder="First name"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Mobile Number */}
            <div className="col-span-1 md:col-span-12">
              <div className="grid grid-cols-1 md:grid-cols-12 gap-2">
                <div className="col-span-1 md:col-span-3">
                  <p className="text-base">Registered mobile number:</p>
                </div>
                <div className="col-span-1 md:col-span-5">
                  <div className="flex gap-1">
                    <span className="flex items-center">+63</span>
                    <InputText
                      keyfilter="int"
                      maxLength={10}
                      placeholder="9xxxxxxxxx"
                      className="flex-1 h-10 border-2 focus:outline-yellow-400 rounded-md p-2"
                      name="userMobile"
                      value={searchCriteria.userMobile}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Age Range */}
            <div className="col-span-1 md:col-span-12">
              <div className="grid grid-cols-1 md:grid-cols-12 gap-2">
                <div className="col-span-1 md:col-span-3">
                  <p className="text-base">Age:</p>
                </div>
                <div className="col-span-1 md:col-span-5">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="text-base">From:</span>
                    <InputText
                      disabled={allAgeFlag}
                      maxLength={3}
                      value={allAgeFlag ? "" : searchCriteria.ageFrom}
                      onChange={handleChange}
                      name="ageFrom"
                      keyfilter="int"
                      className="w-20 h-10 border-2 focus:outline-yellow-400 rounded-md p-2"
                    />
                    <span className="text-base">To:</span>
                    <InputText
                      disabled={allAgeFlag}
                      maxLength={3}
                      value={allAgeFlag ? "" : searchCriteria.ageTo}
                      onChange={handleChange}
                      name="ageTo"
                      keyfilter="int"
                      className="w-20 h-10 border-2 focus:outline-yellow-400 rounded-md p-2"
                    />
                  </div>
                </div>
                <div className="col-span-1 md:col-span-2">
                  <Checkbox
                    label="All"
                    checked={allAgeFlag}
                    onChange={(e) => {
                      setAllAgeFlag(e.target.checked);
                    }}
                  />
                </div>
              </div>
            </div>

            {/* Verified Status */}
            <div className="col-span-1 md:col-span-12">
              <div className="grid grid-cols-1 md:grid-cols-12 gap-2">
                <div className="col-span-1 md:col-span-3">
                  <p className="text-base">Verified Status:</p>
                </div>
                <div className="col-span-1 md:col-span-5">
                  <Select
                    value={searchCriteria.verifiedStatus}
                    items={[
                      { value: "-2", name: "-- All --" },
                      ...VERIFIED_STATUS,
                    ]}
                    onChange={handleChange}
                    name="verifiedStatus"
                  />
                </div>
              </div>
            </div>

            {/* With App */}
            <div className="col-span-1 md:col-span-12">
              <div className="grid grid-cols-1 md:grid-cols-12 gap-2">
                <div className="col-span-1 md:col-span-3">
                  <p className="text-base">With App:</p>
                </div>
                <div className="col-span-1 md:col-span-5">
                  <Select
                    value={searchCriteria.withApp}
                    items={[
                      { value: "-2", name: "-- All --" },
                      { value: 1, name: "Yes" },
                      { value: 0, name: "No" },
                    ]}
                    onChange={handleChange}
                    name="withApp"
                  />
                </div>
              </div>
            </div>

            {/* Registration Date */}
            <div className="col-span-1 md:col-span-12">
              <div className="grid grid-cols-1 md:grid-cols-12 gap-2">
                <div className="col-span-1 md:col-span-3">
                  <p className="text-base">Registration Date:</p>
                </div>
                <div className="col-span-1 md:col-span-5">
                  <PrimereactDateRange
                    onChange={handleChange}
                    startDate={searchCriteria.signupDateFrom}
                    endDate={searchCriteria.signupDateInto}
                    readOnlyInput={true}
                    max={new Date()}
                    min={new Date("2021-01-01")}
                  />
                </div>
              </div>
            </div>

            <div className="col-span-1"></div>

            {/* Buttons */}
            <div className="col-span-1 md:col-span-12">
              <div className="grid grid-cols-4 gap-4">
                <Button
                  onClick={handleSearchResult}
                  className="col-span-3 md:col-span-1 h-10"
                  value="SEARCH"
                />
                <button
                  className="flex items-center gap-2 hover:text-blue-500 cursor-pointer underline"
                  onClick={() => {
                    handleReset();
                  }}
                >
                  <i className="fas fa-undo"></i>
                  <span>Reset</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Main Table */}
      {loading && <LoadingComponent />}
      {data && (
        <Card className="mt-4">
          <TotalRecords count={lockerUserAccountsList.length} />
          <div className="bg-primary-primaryYellow w-full h-24 border-stone-400 border-b-2 text-center">
            <p className="font-bold text-lg m-auto p-2">
              {searchResultSentence}
            </p>
            <div className="flex flex-row-reverse">
              {/* <button className="p-2 bg-green-600 font-bold text-white rounded-md m-2 ml-auto">
								<CSVLink
									data={lockerUserAccountsList}
									filename="locker-user-report"
								>
									Download CSV
								</CSVLink>
							</button> */}
              {/* <button
								className="p-2 bg-green-600 font-bold text-white rounded-md m-2"
								onClick={exportCSV}
							>
								Download Excel
							</button> */}
            </div>
          </div>
          <Table
            id={"cleanup-table"}
            headers={[
              { header_name: "Locker User", header_key: "lockerUser" },
              {
                header_name: "Mobile Number",
                header_key: "userMobile",
                tag: "number",
              },
              { header_name: "Email Address", header_key: "userEmail" },
              { header_name: "Status", header_key: "verifiedStatus" },
              {
                header_name: "Registration Date",
                header_key: "signupDate",
                tag: "date",
              },
              { header_name: "User Type", header_key: "userType" },
            ]}
            items={lockerUserAccountsList}
            linkName={"lockerUser"}
            linkBody={`locker-user-accounts/user-profile-page`}
            fieldId="userId"
            ref={dt}
          />
        </Card>
      )}
    </ContentContainer>
  );
}
